import React, { Component } from "react";
import '../../../modal.css'
import { Spinner } from "../../../resources/media/Spinner";

export default class Modal extends Component {
    render() {
        return <div className="modal display-block"><div className="modal-main center">
        <h2>Upload in Progress</h2>
        <Spinner />
        <p class="content">Please <b>do not</b> close this window while the upload is in progress. Submissions with large attachments can take a significant amount of time to upload.</p>
        <div className="footer"></div>
    </div></div>
    }
}